import { GridHeaders } from '@project-types/GridHeaders';
import { UndeliveredGridData } from '@pages/reporting-pages/undelivered-orders/types/UndeliveredGridData';



export const headersObject: GridHeaders<UndeliveredGridData> = [
	{ label: '', key: '', width: '2.5rem' },
	{ label: 'Zákazník', key: 'orderCustomerSapId', width: '1fr' },
	{ label: 'Název', key: 'name', width: '2fr' },
	{ label: 'Město', key: 'city', width: '2fr' },
	{ label: 'Ulice', key: 'street', width: '2fr' },
	{ label: 'Obchodník', key: 'salesMan', width: '2fr' },
	{ label: 'TLS operátor', key: 'tlsOperator', width: '2fr' },
	{ label: 'Komentář', key: 'comment', width: '2fr' },
	{ label: 'ID objednávky', key: 'orderClientId', width: '1fr' },
	{ label: 'Nový datum doručení objednávky', key: 'orderRequiredDeliveryDate', width: '1fr' },
	{ label: 'Depo', key: 'orderExecutionPlace', width: '1fr' },
	{ label: 'Distribuce', key: 'distributionType', width: '1fr' },
	{ label: 'Distribuční kód', key: 'shipmentDistributionCode', width: '1fr' },
	{ label: 'Fáze', key: 'phase', width: '1fr' },
	{ label: 'Pokrátil', key: 'cancelledBy', width: '1fr' },
	{ label: 'Objem [hl]', key: 'orderSentVolume', width: '1fr' },
	{ label: 'Počet [ks]', key: 'orderSentCount', width: '1fr' },
]